import ListView from "@assets/icons/List_View.svg?react";
import MapView from "@assets/icons/Map_View.svg?react";
import TilesView from "@assets/icons/Tiles_View.svg?react";
import { ViewModeConfig } from "@components/view-mode-selector/view-mode-selector-types";
import { DataViewMode, DataViewModeSubject } from "@store/ui/ui-slice-types";

/** Available view modes for each subject type */
export const SUBJECT_VIEW_MODES: Record<DataViewModeSubject, DataViewMode[]> = {
  projects: ["cards", "list", "map"],
  groups: ["cards", "list"],
};

/** Configuration for each view mode */
export const VIEW_MODES_CONFIG: Record<DataViewMode, ViewModeConfig> = {
  cards: {
    tooltipTitle: "Tiles view",
    iconComponent: TilesView,
  },
  list: {
    tooltipTitle: "List view",
    iconComponent: ListView,
  },
  map: {
    tooltipTitle: "Map view",
    iconComponent: MapView,
  },
};
